import * as actions from 'state/action-types';
import { createAction } from 'state/utils';

export default (operation) => createAction(actions.SET_IN_PROGRESS_OPERATION, { operation });
